import { useMutation, useQueryClient } from "@tanstack/react-query";
import { attemptUpdateBrand } from "../../api/OrgApi";
import { useToast } from "../../context/ToastContext";

export const useUpdateBrand = () => {
  const queryClient = useQueryClient();
  const { setToastMessage } = useToast();

  return useMutation({
    mutationKey: "update-brand",
    mutationFn: ({ brandId, data }) => attemptUpdateBrand(brandId, data),
    onSuccess: (response, variables) => {
      // setToastMessage("Brand updated successfully");

      // Invalidate both specific brand and all brands queries
      queryClient.invalidateQueries({
        queryKey: ["specific-brand", variables.brandId],
      });

      // If we have organization ID in the cache, invalidate all brands for that org
      const orgID = queryClient.getQueryData(["user-profile"])?.organisation_id;
      if (orgID) {
        queryClient.invalidateQueries({
          queryKey: ["org-brands", orgID],
        });
      }
    },
    onError: (error) => {
      setToastMessage("Failed to update brand");
      console.error("Brand update error:", error);
    },
  });
};
